// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
let lastScrollTop = 0;

// Selectors
const HEADER_SELECTOR = '#shopify-section-header';
const ANNOUNCEMENT_BAR_SELECTOR = '.announcement-bar';
const PRODUCT_SECTION = '#shopify-section-product';

// Classes
const STICKY_CLASS = 'is-sticky';
const ANNOUNCEMENT_BAR_HIDDEN_CLASS = 'announcement-bar--hidden';


// -------------------------------------
// Hooks
// -------------------------------------
function handleScroll() {
    let st = document.documentElement.scrollTop;
    const productSection = document.querySelector(PRODUCT_SECTION);

    if (productSection === null) {
        const headerSection = document.querySelector(HEADER_SELECTOR);
        const announcementBar = document.querySelector(ANNOUNCEMENT_BAR_SELECTOR);
        const noScrollBody = document.querySelector('body.noscroll');

        if (st > lastScrollTop || st == 0) { // If scrolling down
            headerSection.classList.remove(STICKY_CLASS);

            // Re-position the regular header depending on if there is the announcement bar or not
            if (noScrollBody && announcementBar == null || noScrollBody && announcementBar.classList.contains(ANNOUNCEMENT_BAR_HIDDEN_CLASS) || st < headerSection.offsetHeight + 33) { // if on mobile and when the menu is open.
                headerSection.style.transform = 'translateY(0)';
            } else if (noScrollBody && announcementBar !== null) { // if on mobile and when the menu is open.
                headerSection.style.transform = 'translateY(-33px)';
            } else {
                headerSection.style.transform = 'translateY(-500px)';
            }

            if (announcementBar !== null) {
                announcementBar.classList.remove(STICKY_CLASS);
            }
        } else if (st < lastScrollTop) { // If scrolling up
            headerSection.classList.add(STICKY_CLASS);

            if (announcementBar !== null) {
                announcementBar.classList.add(STICKY_CLASS);
            }

            // Re-position the sticky header depending on if there is the announcement bar or not.
            if ((announcementBar !== null && announcementBar.classList.contains(ANNOUNCEMENT_BAR_HIDDEN_CLASS)) || announcementBar === null || st <= (headerSection.offsetHeight + 33)) {
                headerSection.style.transform = 'translateY(0)';
            } else {
                headerSection.style.transform = 'translateY(-33px)';
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }
}

function throttle(callback, delay) {
    let time = Date.now();

    return function () {
        if ((time + delay - Date.now()) < 0) {
            callback();
            time = Date.now();
        }
    };
}

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('scroll', throttle(handleScroll, 10));
});